export const image = src => {
  if (src) {
    return process.env.VUE_APP_URL + "storage/" + src;
  }
  return src;
};
